/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { animated } from '@react-spring/web';
import { CardItem } from '../card-item';
import { Filters } from './filters';
import { SearchItem } from '../../../../types/types';
import Button from '@/components/Button';
import Divider from '@/components/Divider';
import { useAnimatedSearchItems } from '../../hooks/useAnimatedSearchItems';

export const ListSearch = ({
  data,
  loadMoreData,
  loadingMore,
  canLoadMore,
}: {
  data: SearchItem[];
  loadMoreData: () => void;
  loadingMore: boolean;
  canLoadMore: boolean;
}) => {
  const transitions = useAnimatedSearchItems(data || []);

  const renderItem = useCallback(
    (item: SearchItem) => (
      <CardItem key={`${(item as any)?.slug || (item as any)?.id}-${item.__typename}`} item={item} />
    ),
    [],
  );

  return (
    <div className="flex flex-col">
      <Filters />

      <Divider />

      <div className="space-y-8">
        <h2 className="!my-0 font-cadiz text-sh-28-32 font-bold">Results</h2>

        {data && data.length > 0 ? (
          <>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {transitions((styles, item) => (
                <animated.div style={styles}>{renderItem(item)}</animated.div>
              ))}
            </div>

            {canLoadMore && (
              <div className="flex justify-center pt-6">
                <Button
                  onClick={loadMoreData}
                  disabled={loadingMore}
                  className="rounded-lg bg-blue-600 px-6 py-2 text-white hover:bg-blue-700">
                  {loadingMore ? (
                    <>
                      <div className="mr-2 h-4 w-4 animate-spin rounded-full border-b-2 border-white"></div>
                      Loading...
                    </>
                  ) : (
                    '+ More'
                  )}
                </Button>
              </div>
            )}
          </>
        ) : (
          data.length === 0 && (
            <div className="py-8 text-center">
              <p className="font-cadiz text-gray-500">No Results</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};
